import { TemplatePage } from './types';

const framePage: TemplatePage = {
  header: {
    color: '#F6F6F6',
    icon: 'images/video-templates/trending-frame.jpg',
    title: 'Frame Video Templates Collection',
    title_meta: '50+ Free Customizable Frame Video Templates',
    description_meta:
      'Speed up your video editing process with Wave.video’s 50+ editable frame video templates.',
    description:
      'Speed up your video editing process with Wave.video’s 50+ editable frame video templates. Give your videos a professional ' +
      'and polished look effortlessly.'
  },
  footer: {
    category: 'Frame',
    description:
      'With the help of Wave.video’s wide range of premade frame video templates, you will be able to create engaging videos ' +
      'for your blog, social media, website, or email newsletter in a matter of minutes. All the templates are easy and free to ' +
      'personalize to suit your brand and topic.'
  },
  content: [
    {
      type: 'templates',
      title: 'Frame Video Templates',
      search: { name: 'frame' }
    },
    {
      type: 'stocks',
      title: 'frame',
      search: { name: 'frame' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default framePage;
